export const exchangeZh = {
  title: '换汇', initiate: '发起换汇', subtitle: '在一般贸易账户间兑换币种，轻松管理多币种资金。',
  records: '换汇记录', funds: '资金变动明细', sourceAccount: '出款账户', selectAccount: '选择出款账户',
  accountSearch: '搜索账户或币种', accountEmpty: '暂无可用于换汇的一般贸易账户',
  accountHint: '仅一般贸易（B2B）账户可进行换汇', business: '一般贸易 (B2B)',
  currencyAccount: '账户',
  bizType: '业务类型',
  sell: '卖出', buy: '买入', fromCurrency: '卖出币种', toCurrency: '买入币种',
  fromAmount: '卖出金额', toAmount: '买入金额', available: '可用余额',
  amountPlaceholder: '请输入卖出金额', buyAmountPlaceholder: '请输入买入金额', currencyPlaceholder: '请选择币种',
  estimate: '预计买入金额', estimateSell: '预计卖出金额', previewPlaceholder: '输入金额后试算',
  openedHint: '已开通币种账户', autoOpenHint: '买入未开通币种时，交易成功后自动开通对应账户',
  tenor: '期限', today: 'TODAY 实时', todayHint: '当前仅支持 TODAY 实时换汇',
  rate: '参考汇率', actualRate: '汇率', rateExpiry: '汇率有效期',
  settlementCutoff: '截止结算日', deliveryMethod: '交割方式',
  deliveryToday: 'TODAY 实时交割，卖出余额即时扣减',
  preview: '试算', submit: '提交', confirm: '确认信息',
  confirmSubmit: '确认换汇', confirmOk: '确认', cancel: '取消', retry: '重试',
  previewHint: '试算结果仅供参考，实际成交以交易实时报价为准。',
  serviceUnavailable: '换汇交易服务暂不可用，当前可进行汇率试算。',
  submitSuccess: '换汇提交成功',
  submitError: '换汇提交失败，请重试',
  loadError: '账户或币种加载失败，请重试', previewError: '暂时无法获取汇率，请重试',
  amountError: '请输入大于零的有效金额', accountRequired: '请先选择出款账户',
  quoteAmountError: '卖出金额和买入金额均须大于零，请调整金额后重试',
  balanceExceeded: '卖出金额超出可用余额',
  precisionLoadError: '币种小数位配置加载失败，请重试',
  currencyRequired: '请选择与卖出币种不同的买入币种',
  howTitle: '换汇说明', howAccount: '选择出款账户', howAccountText: '卖出币种随出款账户确定。',
  howQuote: '核对换汇信息', howQuoteText: '确认卖出金额、买入币种及实时报价。',
  howResult: '查看交易结果', howResultText: '换汇记录及资金明细可在交易查询中查看。',
  createTime: '交易时间', orderNo: '业务订单号', merchantOrderNo: '商户订单号',
  settlementTime: '交割时间', errorMsg: '失败原因',
  status: '状态', success: '成功', processing: '处理中', fail: '失败', all: '全部',
  search: '搜索', reset: '重置', startDate: '开始日期', endDate: '结束日期',
  empty: '暂无换汇交易记录', recordsError: '换汇记录暂时无法加载，请稍后重试',
  beforeAmount: '变动前余额', afterAmount: '变动后余额',
  exportUnavailable: '换汇记录导出暂不可用，请稍后再试'
};

export const exchangeEn = {
  title: 'Exchange', initiate: 'Currency exchange', subtitle: 'Exchange currencies between your general trade accounts.',
  records: 'Exchange records', funds: 'Balance details', sourceAccount: 'Source account', selectAccount: 'Select source account',
  accountSearch: 'Search accounts or currencies', accountEmpty: 'No eligible general trade accounts',
  accountHint: 'Only general trade (B2B) accounts support currency exchange', business: 'General trade (B2B)',
  currencyAccount: 'Account',
  bizType: 'Business type',
  sell: 'Sell', buy: 'Buy', fromCurrency: 'Sell currency', toCurrency: 'Buy currency',
  fromAmount: 'Sell amount', toAmount: 'Buy amount', available: 'Available balance',
  amountPlaceholder: 'Enter sell amount', buyAmountPlaceholder: 'Enter buy amount', currencyPlaceholder: 'Select currency',
  estimate: 'Estimated buy amount', estimateSell: 'Estimated sell amount', previewPlaceholder: 'Enter an amount to preview',
  openedHint: 'Currency account is active', autoOpenHint: 'A new currency account will be opened automatically after a successful exchange',
  tenor: 'Tenor', today: 'TODAY Real-time', todayHint: 'Only TODAY real-time exchange is currently supported',
  rate: 'Reference rate', actualRate: 'Exchange rate', rateExpiry: 'Rate validity',
  settlementCutoff: 'Settlement cut-off', deliveryMethod: 'Delivery method',
  deliveryToday: 'TODAY real-time delivery; sell balance deducted immediately',
  preview: 'Preview', submit: 'Submit', confirm: 'Confirm details',
  confirmSubmit: 'Confirm exchange', confirmOk: 'Confirm', cancel: 'Cancel', retry: 'Retry',
  previewHint: 'This estimate is for reference. The live transaction quote determines the final rate.',
  serviceUnavailable: 'Exchange trading is temporarily unavailable. Rate previews are available.',
  submitSuccess: 'Exchange submitted successfully',
  submitError: 'Failed to submit exchange. Please retry.',
  loadError: 'Unable to load accounts or currencies. Please retry.', previewError: 'Unable to retrieve a rate. Please retry.',
  amountError: 'Enter a valid amount greater than zero', accountRequired: 'Select a source account first',
  quoteAmountError: 'Sell and buy amounts must both be greater than zero. Adjust the amount and retry.',
  balanceExceeded: 'Sell amount exceeds the available balance',
  precisionLoadError: 'Unable to load currency decimal precision. Please retry.',
  currencyRequired: 'Select a buy currency different from the sell currency',
  howTitle: 'How it works', howAccount: 'Select an account', howAccountText: 'The source account determines the sell currency.',
  howQuote: 'Review the exchange', howQuoteText: 'Check the sell amount, buy currency and live quote.',
  howResult: 'View the result', howResultText: 'Find exchange records and balance changes in Transaction Inquiry.',
  createTime: 'Transaction time', orderNo: 'Business order number', merchantOrderNo: 'Merchant order number',
  settlementTime: 'Settlement time', errorMsg: 'Failure reason',
  status: 'Status', success: 'Success', processing: 'Processing', fail: 'Failed', all: 'All',
  search: 'Search', reset: 'Reset', startDate: 'Start date', endDate: 'End date',
  empty: 'No exchange transactions', recordsError: 'Exchange records are temporarily unavailable. Please retry later.',
  beforeAmount: 'Balance before', afterAmount: 'Balance after',
  exportUnavailable: 'Exchange record export is temporarily unavailable. Please try again later.'
};
